import styled from 'styled-components';

import {
  SCREEN_LOCKUP_WIDTH,
  WHITE,
  BLACK,
  PAGE_WIDTH,
  BG_GRAY,
  HAIR_DIAGNOSIS_BUTTONS_HEIGHT,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 0 auto 80px;

  ${media.tabletL`
    background-color: ${BG_GRAY.COMMON_5};
    margin-bottom: 210px;
  `};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  position: relative;
  padding-bottom: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  object-fit: fill;
  /* IE11 では object-fit が適用されないため、object-fit-images モジュールを使用 */
  font-family: 'object-fit: fill;';

  ${media.tabletL`
    padding-bottom: 0;
  `};
`;

export const SliderWrapper = styled.div`
  position: relative;
`;

export const StartBtn = styled.button`
  cursor: pointer;
  position: absolute;
  bottom: -${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  right: 20px;
  height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  line-height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  width: 60%;
  background-color: ${BLACK};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  border: 1px solid ${WHITE};
  color: ${WHITE};
  z-index: 99;

  ${media.tabletL`
    min-width: 350px;
    width: auto;
    font-size: 14px;
    outline: none;
  `};

  :disabled {
    background-color: ${BG_GRAY.COMMON_3};
    pointer-events: none;
  }
`;

export const PrevBtn = styled.button`
  position: absolute;
  bottom: -${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  right: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  cursor: pointer;
  width: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  border: 1px solid ${WHITE};
  background-color: ${BLACK};
  background-position: center;
  background-repeat: no-repeat;
  transition: background-color 0.3s;
  z-index: 999;

  :disabled {
    background-color: ${BG_GRAY.COMMON_3};
    pointer-events: none;
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(-50%, -50%) rotate(-135deg);
    transform-origin: 9px 2px;
    width: 8px;
    height: 8px;
    border-top: 2px solid ${WHITE};
    border-right: 2px solid ${WHITE};
    transition: transform 0.3s;
  }

  ${media.tabletL`
    outline: none;
  `};
`;

export const NextBtn = PrevBtn.extend`
  border: 1px solid ${WHITE};
  border-left: none;
  border-right: none;
  right: 0px;
  z-index: 999;

  ::before {
    transform: translateY(-50%) rotate(45deg);
    transform-origin: 5px 7px;
  }

  ${media.tabletL`
    outline: none;
  `};
`;

export const FinishBtnWrapper = styled.div`
  position: absolute;
  right: 0;
  width: 100%;
`;

export const RightWrapper = styled.div`
  position: absolute;
  bottom: -${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  right: 0;
  z-index: 99;

  ${media.tabletL`
    /* position: static; */
    display: inline-block;
  `};
`;

export const FinishBtn = styled.button`
  cursor: pointer;
  height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  line-height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  background-color: ${BLACK};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  border: 1px solid ${WHITE};
  border-left: none;
  color: ${WHITE};
  padding: 0 28px;

  :disabled {
    background-color: ${BG_GRAY.COMMON_3};
    pointer-events: none;
  }

  ${media.tabletL`
    min-width: 350px;
    outline: none;
  `};
`;

export const StartOverBtn = styled.button`
  position: absolute;
  bottom: -${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  left: 0;
  background-color: ${WHITE};
  height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  width: auto;
  padding-left: 20px;
  text-align: left;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  border: none;
  border-bottom: 1px solid ${BLACK};
  color: ${BLACK};
  z-index: 99;

  ${media.tabletL`
    /* position: static; */
    height: auto;
    width: auto;
    padding: 0;
    left: auto;
    right: 400px;
    border-bottom: none;
    text-align: center;
    margin-right: 3em;
    outline: none;
  `};

  span {
    border-bottom: 1px solid ${BLACK};
    font-weight: 800;
    font-size: 14px;
  }
`;

export const StartOverBtnFinish = StartOverBtn.extend`
  ${media.tabletL`
    line-height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  `};
`;

export const StartOverBtnAbsolute = StartOverBtn.extend`
  position: absolute;
  bottom: -${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  left: 0;
  border: none;
  background-color: ${WHITE};
  height: ${HAIR_DIAGNOSIS_BUTTONS_HEIGHT}px;
  width: auto;
  padding-left: 20px;
  text-align: left;
  z-index: 99;

  span {
    border-bottom: 1px solid ${BLACK};
    font-weight: 800;
    font-size: 14px;
  }

  ${media.tabletL`
    position: absolute;
    bottom: -45px;
    right: 128px;
    left: auto;
    text-align: center;
    padding-left: 0;
    width: auto;
  `};
`;

export const PlaceholderWrapper = styled.div`
  height: 550px;
  display: flex;
`;

export const SlideProgress = styled.p`
  position: absolute;
  left: 0;
  bottom: -38px;
  font-size: 20px;
  font-weight: 600;
  color: #cacaca;
  margin: 0;
  display: none;

  span {
    font-size: 20px;
    font-weight: 900;
    color: ${BLACK};
  }

  ${media.tabletL`
    display: block;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisHomePage/HairDiagnosisHomePage.style.js